import React from 'react';

const ChairmanMessagePage = () => {
  return (
    <div className="bg-white">
      {/* Hero Banner */}
      <div className="relative bg-slate py-20">
        <div className="absolute inset-0 bg-gradient-to-r from-slate to-crimson opacity-90"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">Chairman's Message</h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">Leading with vision, inspiring excellence in education and innovation</p>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 md:px-8">
          {/* Main Content Card */}
          <div className="bg-white rounded-xl shadow-soft p-12 md:p-16">
            <div className="grid md:grid-cols-4 gap-12 mb-8">
              {/* Photo Placeholder */}
              <div className="md:col-span-1">
                <div className="bg-gray-100 rounded-lg aspect-[3/4] flex items-center justify-center">
                  <i className="fas fa-user-tie text-8xl text-gray-400"></i>
                </div>
                <div className="mt-6 text-center">
                  <h3 className="font-bold text-xl text-slate">Dr. Rajesh Kumar</h3>
                  <p className="text-base text-gray-500 mt-2">Chairman</p>
                  <p className="text-sm text-gray-400 mt-1">FiT Engineering College</p>
                </div>
              </div>
            
            {/* Message Content */}
            <div className="md:col-span-3 space-y-6">
              <p className="text-gray-600 leading-relaxed text-lg">
                Dear Students, Faculty, and Staff,
              </p>
              <p className="text-gray-600 leading-relaxed">
                It is with great pride and enthusiasm that I welcome you to FiT Engineering College. As Chairman of this esteemed institution, I am honored to lead an organization that stands at the forefront of technical education and innovation.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our commitment to excellence is unwavering. We believe in nurturing not just skilled professionals, but thoughtful leaders who will shape the future of technology and society. Through our state-of-the-art facilities, distinguished faculty, and industry partnerships, we provide an environment where knowledge meets opportunity.
              </p>
              <p className="text-gray-600 leading-relaxed">
                At FIT, we understand that education extends beyond textbooks and laboratories. We foster a culture of innovation, critical thinking, and ethical responsibility. Our students are encouraged to challenge conventions, explore new frontiers, and develop solutions that make a meaningful impact on the world.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our vision is to create global citizens who are technically proficient, socially responsible, and ready to lead in an ever-evolving world. We continuously strive to update our curriculum, enhance our infrastructure, and provide opportunities that prepare our students for the challenges and opportunities of tomorrow.
              </p>
              <p className="text-gray-600 leading-relaxed">
                As we continue to evolve and adapt to the changing landscape of technology and education, our core values remain constant: integrity, excellence, and service to society. I invite you to be part of our journey as we work together to build a brighter, more technologically advanced future.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Welcome to the FIT family. Together, we will achieve greatness.
              </p>
              <p className="text-gray-600 leading-relaxed font-semibold mt-8">
                Warm regards,<br/>
                <span className="text-crimson text-xl">Dr. Rajesh Kumar</span><br/>
                <span className="text-base font-normal">Chairman, FiT Engineering College</span>
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChairmanMessagePage;